// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image[data-v-1fbf8190],.images[data-v-1fbf8190]{position:absolute;left:0;top:0;width:100%;height:100%}.image[data-v-1fbf8190]{z-index:1}", ""]);
// Exports
module.exports = exports;
